import { useState, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {
    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    Chip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';




import { globalstyles } from '../lib/definitions';
import { myTimestampToDate, propComparator, getSelectedElement, propComparatorDate } from '../utils/ui_utils';
import { format, differenceInMonths } from 'date-fns';
import { AddBox, CheckBox, CheckBoxOutlineBlank, Close, Delete, FactCheck, Info, LibraryAddCheck, Save, ViewList, Warning } from '@mui/icons-material';
import { CowSublistAdvanceDialog } from './CowSublistAdvanceDialog';
import _ from 'lodash';
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { useEvent } from '../context/eventContext';
import { PublicCowDialog } from './PublicCowDialog';
import { PresenceIcon, PresenceSummary, TogglePresenceButton } from '../components/PresenceButton';
import { SideBadge } from '../components/SideBadge';
import { PropertyLabel } from '../definitions/property';

const cleanCow = (cow) => {
    let c = { ...cow }
    delete c.is_in_ring
    return c
}

export const CowSublistDialog = forwardRef(({ handleMoveCow, handleAddCowList, match, editFn, element_list, notDialog, is_public }, ref) => {

    const dialogRef = useRef()
    const childRefDelete = useRef()
    const publicRef = useRef()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(false)
    const [cow_list, setCowList] = useState([])
    const [dynamic_cow_list, setDynamicCowList] = useState([])
    const [linked_cow_list, setLinkedCowList] = useState([])
    const [curElement, setCurElement] = useState({})
    const [selected_cow_id, setSelectedCow] = useState([])
    const [selected_source_cow_id, setSelectedSourceCow] = useState([])
    const [index, setIndex] = useState(-1)
    const [not_completed, setNotCompleted] = useState(0)
    const [confirmMode, setConfirmMode] = useState('dynamic')
    const [showSourceList, setShowSourceList] = useState(true)
    const [showNotPresent, setShowNotPresent] = useState(false)



    useImperativeHandle(ref, () => {
        return {
            onOpen(cl, elem_data,showAll) {
                console.log("DO OPEN", cl, elem_data)
                setOpen(true);
                setShowNotPresent(showAll)
                if (elem_data.use_dynamic_list) {
                    setCowList(cl)
                } else if (cl && cl.link_to_category) {

                } else {
                    if (cl) {
                        setCowList(cl.sort(propComparatorDate('birthdate', true, 'catalog_id')))
                    } else {
                        setCowList([])
                    }

                }
                setCurElement(elem_data)
                if (match) {
                    initData(elem_data)
                } else {
                    setDynamicCowList([])
                }
                setSelectedCow([])
                setIsEdited(false)
            },
            onReload(el) {
                setCowList(el)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleAdd = () => {
        dialogRef.current.onOpen(cow_list, curElement)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
            let new_cl = [...cow_list]
            new_cl.splice(i, 1)
            //            handleAddCowList({ id: curElement.id, cow_list: new_cl })
            setCowList(new_cl)
        }
        childRefDelete.current.confirmDelete('Rimuovi soggetto ', `Sei sicuro di voler rimuovere il soggetto da: <br/><b>${curElement.title}</b>`, cb)
    }


    const editCowList = (cl) => {
        let new_cl = [...cow_list, ...cl]
        console.log("NEW CL ", new_cl)
        handleAddCowList({ id: curElement.id, cow_list: new_cl, new_cow_list: cl })
        if (cl.filter(c => c.is_present === false || c.is_present === undefined).length > 0) {
            setShowNotPresent(true)
        }
        setCowList(new_cl)
        setIsEdited(true)
    }


    const handleMove = () => {
        setIsEdited(true)
        handleMoveCow(cow_list.filter(c => selected_cow_id.includes(c.id)), curElement.id)
    }


    const handleSave = () => {
        const cb = () => {
            if (confirmMode === 'dynamic') {
                editFn({ ...curElement, cow_list: cow_list, complete_source_list: not_completed === 0 }, index)
            } else {
                setCowList(linked_cow_list.filter(c => selected_source_cow_id.includes(c.id)))
                editFn({ ...curElement, cow_list: linked_cow_list.filter(c => selected_source_cow_id.includes(c.id)), complete_source_list: not_completed === 0 }, index)
            }
        }
        if (curElement.cow_list.length === 0 || curElement.status === undefined) {
            cb()
        } else {
            childRefDelete.current.confirmDelete('Aggiorna elenco soggetti', `Sei sicuro di voler aggiornare l'elenco soggetti?<br/> Questa azione <b>cancellerà definitivamente</b> tutte le informazioni di <b>presenza</b> e risultati registrati`, cb)
        }
        //setOpen(false)
    }

    const toggleSelect = (cow_id) => {
        setSelectedCow(c => {
            let _c = [...c]
            const k = _c.indexOf(cow_id)
            if (k < 0) {
                _c.push(cow_id)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }
    const selectAll = () => {
        setSelectedCow(cow_list.map(c => c.id))
    }

    const selectNone = () => {
        setSelectedCow([])
    }

    const toggleSelectSource = (cow_id) => {
        setSelectedSourceCow(c => {
            let _c = [...c]
            const k = _c.indexOf(cow_id)
            if (k < 0) {
                _c.push(cow_id)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }
    const selectAllSource = () => {
        setSelectedSourceCow(linked_cow_list.map(c => c.id))
    }
    const selectPresence = () => {
        setSelectedSourceCow(linked_cow_list.filter(c => c.is_present === true).map(c => c.id))
    }

    const selectNoneSource = () => {
        setSelectedSourceCow([])
    }

    const handleShow = (c) => {
        publicRef.current.onShow(c)
    }


    const initData = async (el) => {
        if (el.source_list_data) {

            setConfirmMode('dynamic')
            const s_key = Object.keys(el.source_list_data)
            const m_list = element_list.filter(e => s_key.includes(e.id))
            let _cow_list = []
            console.log("NOT COMPLETED", m_list.filter(e => e.status !== 'end').length)
            setNotCompleted(m_list.filter(e => e.status !== 'end').length)
            for (const m of m_list) {
                const a = el.source_list_data[m.id]
                const ak = Object.entries(a)[0]
                if (ak) {
                    const result = getSelectedElement(ak[0], m.result_list, 'id')
                    const award = getSelectedElement(ak[0], m.award_list, 'id')
                    let c_list = []
                    c_list = result.cow_list?.filter(c => !c.squalified)
                    if (c_list) {
                        console.log("INIT DATA SUBLIST")
                        if (ak[1].filter_applied === 'red') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'red')
                        } else if (ak[1].filter_applied === 'black') {
                            c_list = c_list.filter(c => c.cow?.cow_type === 'black')
                        }else if (ak[1].filter_applied !== undefined){
                            c_list = c_list.filter(c => c.cow && c.cow[ak[1].filter_applied] === true)
                        }else if (ak[1].filter_applied !== undefined){
                            c_list = c_list.filter(c => c.cow && c.cow[ak[1].filter_applied] === true)
                        }
                    }

                    if (c_list?.length > 0) {
                        if (award.has_position) {
                            c_list = _.map(ak[1].position_list.map(p => (p - 1)), function (item) {
                                return c_list[item]
                            }).filter(c => c !== undefined).map(c => ({ ...cleanCow(getSelectedElement(c.cow.id, m.cow_list, 'id')), award_source_data: { match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id } }))
                        } else {

                            c_list = c_list.filter(c => c !== undefined).map(c => {
                                if (c.cow) {

                                    const update_c = cleanCow(getSelectedElement(c.cow.id, m.cow_list, 'id'))
                                    return { ...update_c, award_source_data: { match_name: m.match_name, match_description: m.match_description, id: m.id, position_id: c.position_id } }
                                } else {
                                    console.log(c, c_list, result, m.result_list)
                                }
                            })
                        }
                        _cow_list = [..._cow_list, ...c_list]
                    }
                }



            }
            setDynamicCowList(_cow_list)
            setLinkedCowList([])
        } else {
            setNotCompleted(0)
            console.log("e", el.linked_category)
            setConfirmMode('linked')
            setDynamicCowList([])
            if (el.link_to_category && el.linked_category && el.source_cow_list) {
                setLinkedCowList(el.source_cow_list)
                setSelectedSourceCow(el.source_cow_list.filter(c => c.is_present === true).map(c => c.id))
            } else {
                setLinkedCowList([])
                setSelectedSourceCow([])

            }
        }
        setShowSourceList(cow_list.length === 0)
    }
    const MyHeader = () => {
        return (
            <>
                <Grid container>
                    <Grid size="grow">
                        Lista soggetti: <b>{curElement.title}</b> <Chip size="small" color="primary" label={<>{cow_list.length} soggetti</>} />
                        <PresenceSummary element_list={cow_list} />
                    </Grid>
                    <Grid size="auto">
                        {(handleAddCowList || (!match || showSourceList) && linked_cow_list.length > 0) &&
                        <TogglePresenceButton setShowNotPresent={setShowNotPresent} showNotPresent={showNotPresent} />
                        }
                    </Grid>
                    <Grid size="grow">
                        {handleAddCowList && (curElement.status === undefined || curElement.status === 'pre') &&
                            <Button size="small" color="secondary" variant='outlined' onClick={handleAdd} startIcon={<AddBox />}>Inserisci altri soggetti</Button>
                        }
                        {match &&
                            <>
                                {linked_cow_list?.length > 0 &&
                                    <SideBadge badgeContent={linked_cow_list.length} color="primary">
                                        {showSourceList ?
                                            <Button size="small" color="secondary" variant='contained' onClick={() => setShowSourceList(s => !s)} startIcon={<ViewList />}>nascondi lista soggetti categoria ({curElement.linked_category?.category_name})</Button>
                                            :
                                            <Button size="small" color="secondary" variant='outlined' onClick={() => setShowSourceList(s => !s)} startIcon={<ViewList />}>visualizza lista soggetti categoria ({curElement.linked_category?.category_name})</Button>
                                        }
                                    </SideBadge>
                                }
                                {dynamic_cow_list?.length > 0 &&
                                    <SideBadge badgeContent={dynamic_cow_list.length} color="primary">
                                        {showSourceList ?
                                            <Button size="small" color="secondary" variant='contained' onClick={() => setShowSourceList(s => !s)} startIcon={<ViewList />}>nascondi lista soggetti sorgente </Button>
                                            :
                                            <Button size="small" color="secondary" variant='outlined' onClick={() => setShowSourceList(s => !s)} startIcon={<ViewList />}>visualizza lista soggetti sorgente </Button>
                                        }
                                    </SideBadge>
                                }
                            </>}
                    </Grid>
                </Grid>
                {linked_cow_list?.length > 0 && showSourceList &&
                    <Grid container flexDirection={"column"} sx={{ fontSize: '16px' }}>
                        <Grid container flexDirection={"row"}>
                            <Grid size={"grow"} sx={{ ...globalstyles.sectionHeader, backgroundColor: 'lightgrey', color: 'black' }}>
                                Soggetti provenienti dalla categoria collegata: <b>{curElement.linked_category?.category_name}</b> - {curElement.linked_category?.category_description}
                            </Grid>
                            <Grid size={"auto"} sx={{ color: 'red' }}>
                            </Grid>
                            {handleAddCowList &&
                                <Grid size="auto" sx={{ alignText: 'right' }}>
                                    <SideBadge badgeContent={selected_source_cow_id.length} color="primary">
                                        <Button size="small" key={'bs'} disabled={(curElement.status !== undefined && curElement.status !== 'pre') || selected_source_cow_id.length === 0} onClick={handleSave} startIcon={<Save />} endIcon={not_completed > 0 && <Warning />} variant="contained" color="warning">{curElement.cow_list?.length === 0 ? 'Conferma inserimento selezionati' : 'Aggiorna'} </Button>
                                    </SideBadge>
                                </Grid>
                            }
                        </Grid>
                        <Grid container sx={{ ...globalstyles.listHeader, height: '25px' }}>
                            {handleAddCowList &&
                                <Grid size={1}>
                                    <ButtonGroup size="small" color="light">
                                        <Tooltip title="deseleziona tutti">

                                            <Button onClick={selectNoneSource} startIcon={<CheckBoxOutlineBlank />}></Button>
                                        </Tooltip>
                                        <Tooltip title="seleziona presenti">

                                            <Button onClick={selectPresence} startIcon={<FactCheck />}></Button>
                                        </Tooltip>
                                        <Tooltip title="seleziona tutti">
                                            <Button onClick={selectAllSource} startIcon={<LibraryAddCheck />}></Button>
                                        </Tooltip>
                                    </ButtonGroup>
                                </Grid>
                            }
                            <Grid size={0.5}>
                                Catalogo
                            </Grid>
                            <Grid size={1}>
                                Matricola
                            </Grid>
                            <Grid size="grow">
                                Nome
                            </Grid>
                            <Grid size="grow">
                                Proprietà
                            </Grid>
                            <Grid size={1}>
                                parti
                            </Grid>
                            <Grid size={1}>
                                Età (mesi)
                            </Grid>
                            <Grid size={1}>
                                Data di nascita
                            </Grid>
                            <Grid size={0.5}>
                            </Grid>
                        </Grid>
                        <Grid sx={{ maxHeight: '40vh', overflowY: 'scroll' }}>

                            {linked_cow_list.sort(propComparatorDate('birthdate', true, 'catalog_id')).map((cow, k) => (
                                <OneCow
                                    cow={cow}
                                    key={k}
                                    index={k}
                                    handleShow={handleShow}
                                    toggleSelect={handleAddCowList ? toggleSelectSource : undefined}
                                    is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                                    is_public={is_public}
                                />
                            ))}
                        </Grid>
                        <Grid container flexDirection={"row"}>
                            <Grid size={"grow"} sx={globalstyles.sectionHeader}>
                                Soggetti realmente inseriti
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {dynamic_cow_list.length > 0 && showSourceList &&
                    <Grid container flexDirection={"column"} sx={{ fontSize: '16px' }}>
                        <Grid container flexDirection={"row"}>
                            <Grid size={"grow"} sx={{ ...globalstyles.sectionHeader, backgroundColor: 'lightgrey', color: 'black' }}>
                                Soggetti provenienti da gare precedenti
                            </Grid>
                            <Grid size={"auto"} sx={{ color: 'red' }}>

                                {not_completed > 0 && <>
                                    <Warning /> Dati parziali: {not_completed}&nbsp;
                                    {not_completed === 1 ?
                                        <>
                                            gara precedente non ancora completata
                                        </>
                                        :
                                        <>
                                            gare precedenti non ancora completate
                                        </>
                                    }
                                </>}
                            </Grid>
                            {handleAddCowList &&
                                <Grid size="auto" sx={{ alignText: 'right' }}>
                                    <Button size="small" key={'bs'} disabled={curElement.status !== undefined && curElement.status !== 'pre'} onClick={handleSave} startIcon={<Save />} endIcon={not_completed > 0 && <Warning />} variant="contained" color="secondary">{curElement.cow_list?.length === 0 ? 'Conferma' : 'Aggiorna'}</Button>
                                </Grid>
                            }

                        </Grid>
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={1}>
                                indice
                            </Grid>
                            <Grid size={0.5}>
                                Catalogo
                            </Grid>
                            <Grid size="grow">
                                Gara disputata
                            </Grid>
                            <Grid size="grow">
                                posizione
                            </Grid>
                            <Grid size="grow">
                                Matricola
                            </Grid>
                            <Grid size="grow">
                                parti
                            </Grid>
                            <Grid size="grow">
                                Età (mesi)
                            </Grid>
                            <Grid size="grow">
                                Data di nascita
                            </Grid>
                        </Grid>
                        {dynamic_cow_list.map((cow, k) => (
                            <DynamicOneCow
                                cow={cow}
                                key={k}
                                index={k}
                                toggleSelect={toggleSelectSource}
                                handleShow={handleShow}
                                is_selected={selected_source_cow_id.indexOf(cow?.id) >= 0}
                                is_public={is_public}
                            />
                        ))}
                        <Grid container flexDirection={"row"}>
                            <Grid size={"grow"} sx={globalstyles.sectionHeader}>
                                Soggetti realmente inseriti
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {cow_list.length > 0 &&
                    <Grid container sx={globalstyles.listHeader}>
                        {handleMoveCow &&
                            <Grid size={1}>
                                <ButtonGroup size="small" color="light">
                                    <Button onClick={selectNone} startIcon={<CheckBoxOutlineBlank />}></Button>
                                    <Button onClick={selectAll} startIcon={<LibraryAddCheck />}></Button>
                                </ButtonGroup>
                            </Grid>
                        }
                        <Grid size={1}>
                            Catalogo
                        </Grid>
                        <Grid size={1}>
                            Matricola
                        </Grid>
                        <Grid size="grow">
                            Nome
                        </Grid>
                        <Grid size="grow">
                            Proprietà
                        </Grid>
                        <Grid size={1}>
                            Parti
                        </Grid>
                        <Grid size={1}>
                            Età (mesi)
                        </Grid>
                        <Grid size={1}>
                            Data di nascita
                        </Grid>
                        <Grid size={0.8}>
                        </Grid>
                    </Grid>
                }
            </>
        )

    }

    const MyContent = () => {
        return (
            <>
                <Grid container flexDirection={"column"} >

                    {cow_list.length > 0 ?
                        <>
                            {cow_list.filter(cow => cow.is_present || showNotPresent).map((cow, k) => (
                                <OneCow
                                    cow={cow}
                                    key={k}
                                    is_public={is_public}
                                    toggleSelect={handleMoveCow !== undefined ? toggleSelect : undefined}
                                    is_selected={selected_cow_id.includes(cow.id)}
                                    handleDelete={handleAddCowList && (curElement.status === undefined || curElement.status === 'pre') && handleDelete}
                                    index={k}
                                    handleShow={handleShow}
                                />
                            ))}
                        </>
                        : <>
                            Nessun soggetto presente
                        </>}
                </Grid>
            </>
        )
    }

    if (notDialog) {
        return (
            <>
                <MyHeader />
                <MyContent />
            </>
        )
    } else {

        return (


            <Dialog open={open} onClose={handleClose} maxWidth="md" fullScreen={true}>
                {handleAddCowList &&
                    <>
                        <CowSublistAdvanceDialog ref={dialogRef} addCow={editCowList} />
                    </>
                }
                <PublicCowDialog ref={publicRef} />
                <DeleteconfirmationSection ref={childRefDelete} />
                <DialogTitle>
                    <MyHeader />
                </DialogTitle>
                <DialogContent>
                    <MyContent />
                </DialogContent>
                <DialogActions>
                    <ButtonGroup>

                        <Button variant='outlined' key={'bc'} onClick={handleClose} startIcon={<Close />}>Chiudi</Button>
                        {handleMoveCow &&
                            <Button disabled={selected_cow_id.length === 0} color="secondary" variant='outlined' onClick={handleMove}>Sposta {selected_cow_id.length > 0 && <>({selected_cow_id.length})</>} su altra categoria</Button>
                        }
                    </ButtonGroup>
                </DialogActions>
            </Dialog>

        )
    }

})



const OneCow = memo(({ cow, toggleSelect, is_selected, handleDelete, index, handleShow, award_value, is_public}) => {
    const birthdate = myTimestampToDate(cow.birthdate)

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
            {toggleSelect &&
                <Grid size={1}>
                    <Button variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(cow.id)} size="small" >{is_selected ? <CheckBox /> : <CheckBoxOutlineBlank />}</Button>
                </Grid>
            }
            <Grid size={0.5}>
                {cow.catalog_id}
            </Grid>
            <Grid size={1} flexDirection={"row"} container>
                {cow.cow_type === 'red' ?
                    <Tooltip placement="right" title="red">
                        <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                    :
                    <Tooltip placement="right" title="black">
                        <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                    </Tooltip>
                }
                {cow.serial}
            </Grid>
            <Grid size="grow">
                {cow.name}
            </Grid>
            <Grid size="grow">
                {cow.property &&
                    <PropertyLabel element={cow.property} />
                }
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(new Date(), birthdate)}
            </Grid>
            <Grid size={1}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
                {award_value &&
                    <Grid size={1}>
                        {cow[award_value]}
                    </Grid>
                }
            <Grid size={0.8} >
                <ButtonGroup size="small" >
                    {console.log("PUBLIC", is_public)}
                    <PresenceIcon is_present={!is_public? cow.is_present: cow.is_present===true? true: false} />

                    <Button size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></Button>
                    {handleDelete &&
                        <Tooltip title="rimuovi soggetto">
                            <Button variant="outlined" color="error" onClick={() => handleDelete(cow, index)} startIcon={<Delete />}></Button>
                        </Tooltip>
                    }
                </ButtonGroup>
            </Grid>
        </Grid>
    )

})


const DynamicOneCow = memo(({ cow, toggleSelect, is_selected, index }) => {
    const { selEvent } = useEvent()
    if (cow) {

        const birthdate = myTimestampToDate(cow?.birthdate)
        const ev_date = myTimestampToDate(selEvent.event_start)
        return (
            <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }}>
                <Grid size={1}>
                    {index + 1}
                </Grid>
                <Grid size={0.5}>
                    {cow.catalog_id}
                </Grid>
                <Grid size="grow">

                    {cow.award_source_data &&
                        <>
                            {cow.award_source_data?.match_name}
                        </>}
                </Grid>
                <Grid size="grow">
                    {cow.award_source_data &&
                        <>
                            {cow.award_source_data?.position_id + 1}
                        </>}
                </Grid>
                <Grid size="grow" flexDirection={"row"} container>
                    {cow.cow_type === 'red' ?
                        <Tooltip placement="right" title="red">
                            <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                        :
                        <Tooltip placement="right" title="black">
                            <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                    }
                    {cow.serial}
                </Grid>
                <Grid size="grow">
                    {cow.birth}
                </Grid>
                <Grid size="grow">
                    {differenceInMonths(ev_date, birthdate)}
                </Grid>
                <Grid size="grow">
                    {format(birthdate, 'dd/MM/yyyy')}
                </Grid>
            </Grid>
        )
    } else {
        return <>
        </>
    }

})
